import React, { useEffect } from 'react';

import PageLayout from 'layouts/PageLayout';
import TeamList from 'components/TeamList';
import BasicSection from 'components/BasicSection';
import PanelContainer from 'components/PanelContainer';
import FormDialog from 'scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import TeamSetAccessLimitsForm from 'scenes/Form/components/TeamSetAccessLimitsForm';
import { CSSTransition } from 'react-transition-group';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import { ENDPOINT } from 'constants/endpoints';
import { useGrid } from 'hooks/useGrid';

import './styles.css';

const MyTeam = props => {
  const { globalActions } = props;
  const grid = useGrid(ENDPOINT.COLLECTION.TEAM);

  useEffect(() => {
    grid.actions.fetch();
  }, []);

  const handleSetAccessLimits = (id, name) => {
    FormDialog({
      title: `Set Access Limits for ${name}`,
      modeless: false,
      compact: true,
      params: { id },
      form: (actions, params) => (
        <TeamSetAccessLimitsForm actions={actions} params={params} />
      ),
    }).then(
      () => {
        globalActions.updateUserPermission('MyTeam');
        grid.actions.fetch();
      },
      response => ResponseErrorDialog({ response })
    );
  };

  return (
    <PageLayout
      pageClass="my-team-page"
      pageTitle="My Team"
      mainContent={
        <>
          {grid.data.init && (
            <CSSTransition
              in={grid.data.init}
              appear={true}
              timeout={ANIMATION_TIMEOUT_APPEAR}
              classNames="fade"
            >
              <PanelContainer
                styles={{ marginBottom: '25px', position: 'relative' }}
              >
                <BasicSection title="My Team">
                  <TeamList
                    data={grid.data.rows}
                    actions={{
                      onSetAccessLimits: handleSetAccessLimits,
                    }}
                  />
                </BasicSection>
              </PanelContainer>
            </CSSTransition>
          )}
        </>
      }
    />
  );
};

export default MyTeam;
